export default __webpack_public_path__ + "static/media/TOS.fd4650c6.pdf";